// extracted by mini-css-extract-plugin
module.exports = {"updateWrapper":"privacyPolicyUpdate_updateWrapper__BcBh4","contentWrapper":"privacyPolicyUpdate_contentWrapper__pA9hw","btnWrapper":"privacyPolicyUpdate_btnWrapper__DTElK"};